import { render, staticRenderFns } from "./FormSurvey.vue?vue&type=template&id=65682066"
import script from "./FormSurvey.vue?vue&type=script&lang=js"
export * from "./FormSurvey.vue?vue&type=script&lang=js"
import style0 from "./FormSurvey.vue?vue&type=style&index=0&id=65682066&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports